export const LANG_COUNTRY = ':langCountry';

/*
footer types for cashing
 */
export const FOOTER_TYPE_SEND_LANDING = '/send-money';
export const FOOTER_TYPE_REQUEST_LANDING = '/request';
export const FOOTER_TYPE_SIMPLE = '/simple';
export const FOOTER_TYPE_DEFAULT = '/default';
export const FOOTER_TYPE_BUSINESS = '/business';
